var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSomethingWentWrong(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42.5,
    r: 42.5,
    fill: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.037 26.775H23.8a3.825 3.825 0 00-3.825 3.825v18.185A3.825 3.825 0 0023.8 52.61h37.237a3.825 3.825 0 003.825-3.825V30.6a3.825 3.825 0 00-3.825-3.825zM23.8 25.5a5.1 5.1 0 00-5.1 5.1v18.185a5.1 5.1 0 005.1 5.1h37.237a5.1 5.1 0 005.1-5.1V30.6a5.1 5.1 0 00-5.1-5.1H23.8z",
    fill: "#333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5 52.913c.352 0 .638.285.638.637v5.1a.637.637 0 11-1.275 0v-5.1c0-.352.285-.637.637-.637zM33.362 62.05c0-.352.285-.637.637-.637H50.33a.638.638 0 010 1.275H34a.637.637 0 01-.638-.638z",
    fill: "#333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.022 46.412a.637.637 0 01.245-.868c1.8-1.006 5.078-2.739 10.379-2.739 4.938 0 7.801 1.623 9.552 2.761a.637.637 0 11-.695 1.07c-1.626-1.058-4.249-2.556-8.857-2.556-4.988 0-8.04 1.618-9.757 2.577a.637.637 0 01-.867-.245z",
    fill: "#0DD1C5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.392 35.87a1.02 1.02 0 11-2.04 0 1.02 1.02 0 012.04 0zM38.59 35.87a1.02 1.02 0 11-2.04 0 1.02 1.02 0 012.04 0z",
    fill: "#0DD1C5"
  })));
}
export default SvgSomethingWentWrong;